__turbopack_context__.v({
  "icon": "xEbWcW_icon",
  "inline": "xEbWcW_inline",
  "label": "xEbWcW_label",
  "link": "xEbWcW_link",
});
